import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DETAILS_SHARE_CTA_COPY = defineFcm('petition_details_share_cta_copy')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Action Button',
		description:
			'Rollout kill switch for the share CTA copy experiment (3-arm label test on the mobile share affordance below Sign: control "Share this petition", variant_1 "Share petition", variant_2 "Share"), independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-97578',
		import: false,
		template: {
			enabled: false,
			experimentName: 'petition_details_share_cta_copy_experiment',
		},
	});
